import IdentityClient from "./IdentityClient";
import { Constants } from "../../constants/constants";

const TwoFactorAuthService = {

    async details(data?: any) {
        const result = await IdentityClient().get(Constants.ApiPath.TWO_FACTOR_AUTH.DETAIL);
        return result.data.result;
    },

    async setupAuthenticator(data?: any) {
        const result = await IdentityClient().get(Constants.ApiPath.TWO_FACTOR_AUTH.SETUP_AUTHENTICATOR);
        return result.data;
    },

    async verifyAuthenticator(data: { verificationCode: string }) {
        const result = await IdentityClient().post(Constants.ApiPath.TWO_FACTOR_AUTH.VERIFY_AUTHENTICATOR, data);
        return result.data;
    },

    async disableT2A() {
        const result = await IdentityClient().post(Constants.ApiPath.TWO_FACTOR_AUTH.DISABLE_2FA);
        return result.data;
    },

    async resetAuthenticator() {
        const result = await IdentityClient().post(Constants.ApiPath.TWO_FACTOR_AUTH.RESET_AUTHENTICATOR);
        return result.data;
    },



}

export default TwoFactorAuthService